import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { ICategory } from "../types/index";
import { ICreateCategoryFormData } from "@pages/CreateCategory/types";

export const certificateCategoryApi = createApi({
  reducerPath: "certificateCategoryApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getCategories: builder.query<{ certificateCategory: ICategory[]; count: number}, FilterParams>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/certificate-categories/dashboard?${queryString}`;
      },
    }),
    getCategoryById: builder.query<ICategory, string>({
      query: (categoryId) => `/certificate-categories/${categoryId}`,
    }),
    createCategory: builder.mutation<void, ICreateCategoryFormData>({
      query: (body) => ({
        url: "/certificate-categories",
        method: "POST",
        body,
      }),
    }),
    updateCategory: builder.mutation<void, any>({
      query: ({ id, formData }) => ({
        url: `/certificate-categories/${id}`,
        method: "PATCH",
        body: formData,
      }),
    }),
    deleteCategory: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/certificate-categories/${id}`,
        method: "DELETE",
      }),
    }),
    reorderCategories: builder.mutation<void, any>({
      query: (body) => ({
        url: `/certificate-categories/reorder`,
        method: "PATCH",
        body: {
          orders: body
        }
      }),
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useLazyGetCategoriesQuery,
  useDeleteCategoryMutation,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useLazyGetCategoryByIdQuery,
  useReorderCategoriesMutation
} = certificateCategoryApi;
